module.exports = __webpack_public_path__ + "img/outfit_change2.ea402665.png";